import {useState, SetStateAction, useEffect} from 'react';
import {
  Drawer,
  TextField,
  Stack,
  Typography,
  Divider,
  Box,
  Grid,
  Tab,
  Tabs,
  Button,
  Alert,
  Snackbar
} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useForm, FormProvider, Controller} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import * as APIService from '@shared/services/service-handlers/PrivateService';
import DialogToolBar from './AdditionData/DialogToolBar';
import {CustomFile, UploadProps} from 'src/minimal-components/upload';
import {
  RHFCheckbox,
  RHFEditor,
  RHFSelect,
  RHFSingleUpload
} from 'src/minimal-components/hook-form';
import Resources from './AdditionData/Resources';
import NewFilesLockProperties from './AdditionData/NewFilesLockProperties';
import TipTapEditor from './AdditionData/editor/editors';
import {useAppContext} from '@context/AppContext';
import {getSearchForm} from '@shared/services/service-handlers/PrivateService';
import EncryptUtils from 'src/utils/EncryptUtils';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {enqueueSnackbar} from 'notistack';
import {LoadingScreen} from '@components/loading-screen';
import {LoadingButton} from '@mui/lab';
import {BASE_RECORD_ID, LMS_IS_ADMIN} from 'src/routes/BaseRoute';
import {useModulePreviewContext} from '@context/ModulePreviewContextProvider';
const StyledLabel = styled('span')(({theme}) => ({
  ...theme.typography.caption,
  fontSize: '0.9rem',
  flexShrink: 0,
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightSemiBold
}));
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: number;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_sub_type_id: number;
    module_link_id: number;
    module_id: number;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: number;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_sub_type_id: number;
      module_link_id: number;
      module_id: number;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}
interface IKanbanTask {
  id: string;
  name: string;
  Duration?: number | null;
  description?: string;
  MarkMandatory?: boolean;
  content: string;
  mark_intro_content?: boolean;
}
interface Propsnew extends Omit<UploadProps, 'file'> {
  multiple?: boolean;
}

interface Props extends Propsnew {
  task: any;
  uiFieldsdata: any;
  taskDone: any;
  // eslint-disable-next-line react/boolean-prop-naming
  openDetails: boolean;
  onCloseDetails: VoidFunction;
  onUpdateTask?: (updateTask: IKanbanTask) => void;
}

export default function AddContent({
  task,
  uiFieldsdata,
  openDetails,
  onCloseDetails,
  onUpdateTask,
  taskDone,
  ...other
}: Props) {
  const {
    appState: {applicationName}
  } = useAppContext();
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const {ModulePreviewData, SetModulePreviewData} = useModulePreviewContext();
  const [showData, setShowDate] = useState();
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const [assignmentloader, setAssignmentLoader] = useState(false);
  const [tabActive, setTabsActive] = useState<boolean>(true);
  const [uiFields, setUiFields] = useState<any>(uiFieldsdata);
  const [insertedId, setInsertedId] = useState<any>(undefined);
  const [isloaded, setIsLoaded] = useState(false);
  // Validation schema using yup
  const validationSchema = yup.object().shape({
    taskName: yup.string().required('Content name is required'),
    Duration: yup.number().nullable().notRequired(),
    content: yup.string().required('Content is required'),
    description: yup.string().notRequired(),
    MarkMandatory: yup.boolean().nullable().notRequired(),
    mark_intro_content: yup.boolean().nullable().notRequired()
  });
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      taskName: task?.data?.name || '',
      Duration: task?.data?.time || null,
      description: task?.data?.description || '',
      content: task?.data?.content || '',
      MarkMandatory: task?.data?.mark_as_mandatory || false,
      mark_intro_content: task?.data?.mark_intro_content || false
    }
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [saved, setSaved] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(0);
  const handleChange = (event: any, newValue: SetStateAction<number>) => {
    if (tabActive) {
      setOpenSnackbar(true); // Show the snackbar when `tabActive` is true
    } else {
      setActiveTab(newValue); // Switch tabs
    }
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
    setSaved(false);
  };
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: {errors, isSubmitting}
  } = methods;

  const values = watch();
  const findFileInModule = (
    data: any[],
    moduleId: number,
    fileId: number,
    type: string
  ) => {
    const module = data.find(m => m.id == moduleId);
    if (!module) return null;
    const file = module.files?.find(
      (f: {id: number; type: string}) => f.id == fileId && f.type === type
    );
    return file ?? null;
  };

  const init = async () => {
    try {
      setAssignmentLoader(true);
      if (uiFields === undefined || uiFieldsdata === undefined) {
        const res = await getSearchForm(
          applicationName,
          'module',
          'AddContent'
        );
        await setUiFields(res.searchForm);
      }
      setUiFields(uiFieldsdata);
      const fileData = findFileInModule(
        ModulePreviewData,
        Number(insertedId?.data[0].module_id),
        Number(insertedId?.data[0].inserted_id),
        insertedId?.data[0].type
      );
      if (fileData) {
        setValue('taskName', fileData.name || '');
        setValue('Duration', fileData.time || null);
        setValue('description', fileData.description || '');
        setValue('content', fileData.content || '');
        setValue('MarkMandatory', fileData.mark_as_mandatory || true);
        setValue('mark_intro_content', fileData.mark_intro_content || false);
      } else {
        console.log('File not found');
      }

      // await handleLegacyAppChange(
      //   'SubmissionType',
      //   'SubmissionType',
      //   res.searchForm
      // );
      // if (res.searchForm && (insertedId || task?.inserted_id)) {
      //   const {sql_data} = res.searchForm['create_sql'];
      //   let operations;
      //   if (insertedId || task?.inserted_id) {
      //     operations = 'SEARCH';
      //   }
      //   const data: any = {
      //     sql_data: sql_data,
      //     data: {id: insertedId?.data[0]?.inserted_id || task?.inserted_id,
      //       course_overview_id: uniqueId},
      //     operation: operations
      //   };
      //   const encryptRequestData = EncryptUtils.encryptedData(data);
      //   const result = await APIService.getLMSResultsData(
      //     applicationName,
      //     'LMS',
      //     {
      //       tk: encryptRequestData
      //     }
      //   );
      //   setValue('taskName', result.data[0]?.name || '');
      //   setValue('Duration', result.data[0]?.Duration || null);
      //   setValue('description', result.data[0]?.description || '');
      //   setValue('content', result.data[0]?.content || '');
      //   setValue('MarkMandatory', result.data[0]?.mark_as_mandatory || true);
      //   setValue(
      //     'mark_intro_content',
      //     result.data[0]?.mark_intro_content || false
      //   );
      //   // if (result.data[0].assignment_submission_type_id) {
      //   //   setSubmissionType(result.data[0].assignment_submission_type_id);
      //   //   setValue(
      //   //     'SubmissionType',
      //   //     result.data[0].assignment_submission_type_id
      //   //   );
      //   // }

      //   setAssignmentLoader(false);
      // }

      setAssignmentLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setAssignmentLoader(false);
    }
  };
  // useEffect(() => {
  //   if (taskDone?.operation === 'INSERT' && insertedId === undefined) {
  //     setInsertedId(undefined);
  //   } else if (insertedId !== undefined) {
  //     setInsertedId(insertedId);
  //   } else {
  //     setInsertedId({
  //       data: [
  //         {
  //           module_id: task?.module_id,
  //           inserted_id: task?.inserted_id,
  //           type: 'content'
  //         }
  //       ]
  //     });
  //   }
  // }, [activeTab]);
  // Handle removing all files
  useEffect(() => {
    const fetchData = async () => {
      if (task) {
        setTabsActive(false);
      }
      if (taskDone?.operation === 'INSERT' && insertedId === undefined) {
        setInsertedId(undefined);
      } else if (insertedId !== undefined) {
        setInsertedId(insertedId);
      } else {
        setInsertedId({
          data: [
            {
              module_id: task?.module_id,
              inserted_id: task?.inserted_id,
              type: 'content'
            }
          ]
        });
      }
      await init();
    };

    fetchData();
  }, [activeTab]);
  const onSubmit = async (datavalue: any) => {
    onUpdateTask?.({
      ...task,
      name: datavalue.taskName,
      Duration: datavalue.Duration,
      description: datavalue?.description,
      mark_as_mandatory: datavalue?.MarkMandatory,
      mark_intro_content: datavalue?.mark_intro_content
    });
    try {
      if (uiFields) {
        const {sql_data} = uiFields['create_sql'];
        let operations;
        if (taskDone?.id && taskDone?.operation) {
          operations = taskDone?.operation;
          datavalue.module_id = taskDone?.id;
        }
        if (insertedId && (insertedId.data.length > 0 || task?.data?.id)) {
          operations = 'UPDATE';
          datavalue.page = 1;
          datavalue.id = insertedId.data[0].inserted_id || task?.data?.id;
        }
        datavalue.course_overview_id = uniqueId;
        datavalue.isAdmin = lmsisAdmin === 'True';
        // datavalue.bloburls = datavalue.bloBurls[0].blobUrl;
        setIsLoaded(true);
        const data: any = {
          sql_data: sql_data,
          data: datavalue,
          operation: operations
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await APIService.getLMSResultsData(
          applicationName,
          'LMS',
          {
            tk: encryptRequestData
          }
        );
        if (result.data[0]) {
          setInsertedId({data: [{...result.data[0], type: 'content'}]});
        }
        const processModulesData = (data: ModuleData[]) => {
          return data.map(module => ({
            ...module,
            files:
              module.files?.map(file => ({
                ...file,
                locked_linked_items:
                  typeof file.locked_linked_items === 'string'
                    ? JSON.parse(file.locked_linked_items) // 🛠️ Parse if string
                    : file.locked_linked_items || [], // Keep array or default to empty
                additionalFiles:
                  typeof file.additionalFiles === 'string'
                    ? JSON.parse(file.additionalFiles) // 🛠️ Parse if string
                    : file.additionalFiles || [] // Keep array or default to empty
              })) || []
          }));
        };
        const syncExpandedStates = (
          transformed: ModuleData[],
          existing: ModuleData[]
        ) => {
          return transformed.map(module => {
            const matchingModule = existing.find(e => e.id === module.id);

            if (!matchingModule) return module;

            // Sync the `expanded` flag
            const updatedModule = {
              ...module,
              expanded: matchingModule.expanded || false,
              files:
                module?.files &&
                module?.files.map(file => {
                  const matchingFile =
                    matchingModule?.files &&
                    matchingModule.files.find(f => f.id === file.id);
                  return {
                    ...file,
                    fileexpanded: matchingFile?.fileexpanded || false
                  };
                })
            };

            return updatedModule;
          });
        };

        // Handling API result
        if (result.data[1]) {
          const transformData = await processModulesData(result.data[1]);
          const updatedTransformed = syncExpandedStates(
            transformData,
            ModulePreviewData
          );
          await SetModulePreviewData(updatedTransformed);
        }
        setIsLoaded(false);
        setSaved(true);
        setTabsActive(false);
        setActiveTab(1);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoaded(false);
    }
    setTabsActive(false);
  };
  return (
    <FormProvider {...methods}>
      <Drawer
        open={openDetails}
        onClose={onCloseDetails}
        anchor="right"
        slotProps={{
          backdrop: {invisible: true}
        }}
        PaperProps={{
          sx: {
            width: {
              xs: 1,
              sm: '47vw'
            }
          }
        }}>
        <DialogToolBar
          title={task ? 'Edit Content' : 'Add Content'}
          onCloseDetails={onCloseDetails}
        />
        <Divider />
        <Box sx={{width: '100%'}}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={activeTab}
                onChange={handleChange}
                variant="fullWidth"
                textColor="primary"
                sx={{
                  backgroundColor: '#F4F6F8',
                  '& .MuiTab-root': {
                    fontSize: '16px',
                    fontWeight: '500',
                    '&:hover': {
                      backgroundColor: '#e0e0e0', // Change background on hover
                      borderRadius: 2
                    }
                  },
                  '& .MuiTab-root.Mui-selected': {
                    color: 'primary.main',
                    margin: 1,
                    backgroundColor: 'white',
                    borderRadius: 2
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#637381',
                    height: 0
                  }
                }}>
                <Tab label="Basic Info" />
                <Tab
                  label="Lock Properties"
                  disabled={assignmentloader || isloaded}
                />
                <Tab
                  label="Resources"
                  disabled={assignmentloader || isloaded}
                />
              </Tabs>
            </Grid>
          </Grid>
        </Box>
        {activeTab === 0 &&
          (assignmentloader ? (
            <Stack
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              minHeight={'50vh'}>
              <LoadingScreen />
            </Stack>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} style={{overflowY: 'auto'}}>
              <Stack spacing={1.5} sx={{pt: 3, pb: 5, px: 2.5}}>
                {/* Task Name */}
                <Stack spacing={2} direction="column">
                  <StyledLabel>Name</StyledLabel>
                  <Controller
                    name="taskName"
                    control={control}
                    render={({field}) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        error={!!errors.taskName}
                        helperText={errors.taskName?.message}
                      />
                    )}
                  />
                </Stack>
                <Stack spacing={2} direction="column">
                  <StyledLabel>Duration (Minutes)</StyledLabel>
                  <Controller
                    name="Duration"
                    control={control}
                    defaultValue={null} // Initial value is null
                    rules={{
                      validate: value => value !== 0 || 'Duration cannot be 0' // Custom validation
                    }}
                    render={({field}) => (
                      <TextField
                        {...field}
                        fullWidth
                        size="small"
                        type="number"
                        error={!!errors.Duration}
                        helperText={errors.Duration?.message}
                        onChange={event => {
                          const newValue = event.target.value;
                          if (newValue === '' || parseInt(newValue, 10) > 0) {
                            field.onChange(
                              newValue === '' ? null : parseInt(newValue, 10)
                            );
                          }
                        }}
                        value={field.value ?? ''}
                      />
                    )}
                  />
                </Stack>
                <Stack spacing={1.5}>
                  <Typography variant="subtitle2">Content</Typography>
                  <RHFEditor
                    name="content"
                    imagesVideoOpen={false}
                    toolbarneeded={true}
                  />
                </Stack>
                <Stack spacing={2} direction="column">
                  <StyledLabel>Description</StyledLabel>
                  <Controller
                    name="description"
                    control={control}
                    render={({field}) => (
                      <TextField
                        {...field}
                        fullWidth
                        multiline
                        size="small"
                        InputProps={{
                          sx: {
                            typography: 'body2',
                            minHeight: '12vh',
                            alignItems: 'baseline'
                          }
                        }}
                        sx={{minHeight: '12vh'}}
                        error={!!errors.description}
                        helperText={errors.description?.message}
                      />
                    )}
                  />
                </Stack>
                <Stack direction="row">
                  <RHFCheckbox
                    name="MarkMandatory"
                    label="Mark content as mandatory"
                  />
                </Stack>
                {/* <Stack direction="row">
                  <RHFCheckbox
                    name="mark_intro_content"
                    label="Mark as intro content"
                  />
                </Stack> */}

                <Stack display="flex" flexDirection="row-reverse">
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    color="info"
                    loading={isloaded}
                    disabled={isSubmitting}
                    onClick={() => {
                      if (!errors) {
                        onSubmit;
                      }
                    }}>
                    Save
                  </LoadingButton>
                </Stack>
              </Stack>
            </form>
          ))}

        {activeTab === 1 && (
          <NewFilesLockProperties
            uiFields={uiFields}
            Moduledata={task?.data ? task.data : undefined}
            insertdata={insertedId}
            tableNameEntity="ModuleContentListSubList"
          />
        )}
        {activeTab === 2 && (
          <Resources
            uiFields={uiFields}
            Moduledata={task?.data ? task.data : undefined}
            insertdata={insertedId}
            tableNameEntity="ContentModuleResourseContents"
          />
        )}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
          <Alert
            onClose={handleSnackbarClose}
            severity="warning"
            sx={{width: '40vw'}}>
            Basic information data must be added before accessing other tabs.
          </Alert>
        </Snackbar>
        <Snackbar
          open={saved}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{width: '40vw'}}>
            Basic Info is Saved
          </Alert>
        </Snackbar>
      </Drawer>
    </FormProvider>
  );
}
